import { Modules } from "@lib/titan2/dist/game/Constants";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
export class GameCoinWinOverlayProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.collectionSpineProperties = new SpineProperties("CashCollection", Modules.GAME);
        this.collectionSpineProperties.position.set(962, 920);
    }
}
//# sourceMappingURL=GameCoinWinOverlayProperties.js.map